<template>
  <div class="flex-col h-100">
    <!-- 滚动时显示 -->
    <div class="top-line"
      v-show="isFixed">
      <span class="iconfont iconarrowleft-outline back-info"
        @click="goBack"></span>
      <label class="news-title1">{{item.newsTitle | ellipsis(20)}}</label>
    </div>
    <div class="flex-col"
      v-show="!isFixed">
      <div class="flex-row news-info"
        style="margin: 8px 1rem;">
        <span class="iconfont iconarrowleft-outline back-info"
          @click="goBack"></span>
      </div>
      <div class="flex-col"
        style="margin: 5px 1rem 10px 1rem;">
        <label class="news-title">{{item.newsTitle}}</label>
        <div class="flex-row news-info">
          <label>{{ $t('newsFrom') }}{{item.domain}}</label>
          <label>{{item.publishDate}}</label>
        </div>
      </div>
    </div>

    <div class="detail-info"
      id='detail-info'
      v-on:scroll.passive="handleScroll">

      <div v-if="item.isAdd"
        v-html="item.newsContent">

      </div>
      <div v-else>
        <div v-for="cont in contentsArr"
          :key="cont.rank">
          <div v-if="cont.image">
            <van-image width="100%"
              :src="'http://www.xiniudata.com/file/'+cont.image"
              fit="cover"
              lazy-load />
          </div>
          <div v-else
            class="content">
            {{cont.content}}
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import common from "@common/common";
import webService from "../../network/webService";
import _ from "lodash";
export default {
  name: "NewsDetail",
  components: {},
  data () {
    return {
      isFixed: false,
      item: {},
      isMark: false,
      contentsArr: [],
    };
  },
  filters: {
    ellipsis (_val, len) {
      if (!len) {
        len = 21;
      }
      if (!_val) return "";
      if (_val.length > len) {
        return _val.slice(0, len) + "...";
      }
      return _val;
    },
  },
  created () {
    var id = this.$route.query.id;
    var type = this.$route.query.type;
    if (id) {
      if (type == 0) {
        this.getNewInfoById(id);
      } else if (type == 1) {
        this.getMarketNewsById(id);
      }
    }
  },
  mounted () {
    var id = this.$route.query.id;
    var FavoriteFilter = {
      FavoriteType: common.favoriteTypeEnum.News,
      RelationShipId: id,
    };
    webService
      .GetUserFavoriteRelationshipsByRelId(FavoriteFilter)
      .then((res) => {
        console.log(res.data);
        if (res.data) {
          this.isMark = true;
        } else {
          this.isMark = false;
        }
      });

    common.addViewHistory(
      this.$route.query.id,
      common.favoriteTypeEnum.News
    );
  },
  methods: {
    handleScroll () {
      // let bodyinfo = document.getElementById("detail-info");
      // if (bodyinfo) {
      //   if (bodyinfo.scrollTop > 0) {
      //     this.isFixed = true;
      //   } else {
      //     this.isFixed = false;
      //   }
      // }
    },
    markRel (isboolmark) {
      this.isMark = isboolmark;
      let dto = {
        RelationshipId: this.item.id,
        FavoriteType: common.favoriteTypeEnum.News,
        IsCancel: !isboolmark,
      };
      webService.addFavoriteRelationship(dto).then((res) => {
        console.log(res);
        if (res.data && res.data.success) {
          let msg = isboolmark ? "已收藏" : "取消收藏";
          this.$toast.success(msg);
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
    processContent (data) {
      if (data.isAdd != true) {
        this.contentsArr = JSON.parse(data.newsContent);
      } else {
      }

      this.item = data;
      this.item.publishDate = this.$moment(this.item.publishDate).format(
        "DD/MM/YYYY"
      );
    },
    getNewInfoById (id) {
      webService.getNewsById(id).then((res) => {
        this.processContent(res.data);
      });
    },
    getMarketNewsById (id) {
      webService.getMarketNewsById(id).then((res) => {
        this.processContent(res.data);
      });
    },
    goBack () {
      // this.$router.push({
      //     path: "/home/overview",
      // });
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-line {
  margin: 1rem;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.news-title1 {
  color: #2d2d2d;
  font-size: 15px;
  font-weight: 600;
  flex: auto;
  padding-left: 5px;
}
.back-info {
  font-size: 25px;
  color: darkgray;
}
.news-title {
  color: #2d2d2d;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 1rem;
  max-height: 60px;
  overflow: hidden;
  min-height: 40px;
}
.news-info {
  justify-content: space-between;
  font-size: 12px;
  color: #7d7d7d;
}
.detail-info {
  border-top: 8px solid #f2f2f2;
  font-size: 14px;
  padding: 1rem;
  color: #464646;
  overflow: auto;
  line-height: 1.4rem;
  .content {
    text-indent: 2em;
    word-break: break-all;
    color: #464646;
    line-height: 24px;
  }
}
.split-info {
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/overview/NewsDetail.vue